import { AbstractBexWISEService } from "../bexWISEResolutionService/AbstractBexWISEService";
import {
   IAppointmentDataService,
   IBookAppointmentRequest,
   IBookAppointmentResponse,
   ICancelAppointmentResponse,
   INonAuthenticatedDonorAppointmentRequest,
   IRescheduleAppointmentRequest,
} from "./IAppointmentDataService";
import { IServerErrorArrayResponse } from "../../../types/IServerErrorArrayResponse";
import { IAppointment } from "../../../types/IAppointment";

export class AppointmentDataService
   extends AbstractBexWISEService
   implements IAppointmentDataService
{
   public bookAppointment(
      bookAppointmentRequest: IBookAppointmentRequest,
      // SCREDP-112 - Prevent multiple submissions while save request operations are executing
      startLoading,
      stopLoading
   ): Promise<IBookAppointmentResponse> {
      return this.postBex(
         `donors/${bookAppointmentRequest.donorId}/appointments`,
         bookAppointmentRequest,
         // SCREDP-112 - Prevent multiple submissions while save request operations are executing
         startLoading,
         stopLoading
      );
   }

   public cancelAppointment(
      donorId: string,
      appointmentId: string,
      // SCREDP-112 - Prevent multiple submissions while save request operations are executing
      startLoading,
      stopLoading
   ): Promise<ICancelAppointmentResponse> {
      return this.deleteBex(
         `donors/${donorId}/appointments/${appointmentId}`,  
         // SCREDP-112 - Prevent multiple submissions while save request operations are executing
         startLoading,
         stopLoading
      );
   }

   public requestAppointment(
      appointmentRequest: INonAuthenticatedDonorAppointmentRequest,
      // SCREDP-112 - Prevent multiple submissions while save request operations are executing
      startLoading,
      stopLoading
   ): Promise<IServerErrorArrayResponse> {
      return this.postBex(
         `appointments/prospective`, 
         appointmentRequest,
         // SCREDP-112 - Prevent multiple submissions while save request operations are executing
         startLoading,
         stopLoading
      );
   }

   public rescheduleAppointment(
      rescheduleAppointmentRequest: IRescheduleAppointmentRequest,
      reschedulingAppointmentId: number,
      // SCREDP-112 - Prevent multiple submissions while save request operations are executing
      startLoading,
      stopLoading
   ): Promise<IServerErrorArrayResponse> {
      return this.putBex(
         `donors/${rescheduleAppointmentRequest.donorId}/appointments/${reschedulingAppointmentId}`,
         rescheduleAppointmentRequest,
         // SCREDP-112 - Prevent multiple submissions while save request operations are executing
         startLoading,
         stopLoading
      );
   }

   public getDonorAppointment(
      donorId: string,
      appointmentId: string,
   ): Promise<IAppointment> {
      return this.getBex<IAppointment>(
         `donors/${donorId}/appointments/${appointmentId}`,
      );
   }

   public getDonorAppointments(donorId: string): Promise<IAppointment[]> {
      return this.getBex<IAppointment[]>(`donors/${donorId}/appointments`);
   }
}
